import { put } from 'redux-saga/effects'
import { clearActiveChatAction } from '../../actions'
import { finalCloseChatAction } from '../../handles/finalCloseChatAction'
import { refreshChatsCountAction } from '../../handles'
import { update } from '../_http/chat'

export function* finalCloseChatSaga(action: ReturnType<typeof finalCloseChatAction.request>) {
  const { chat } = action.payload
  try {
    yield update(chat.id, { ...chat, updatedAt: new Date().getTime() })
    yield put(finalCloseChatAction.success())
    yield put(refreshChatsCountAction())
    yield put(clearActiveChatAction())
  } catch (error) {
    console.error('Error when ending chat:', error)
    yield put(finalCloseChatAction.failure(error))
  }
}
